// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ktmM","rightAdornment":"Header_rightAdornment__3h5s6"};